<main class="contact-page">
  <div class="contact-card">
    <img src="./assets/img/rightbin_logo_text.svg" alt="Rightbin" class="contact-card__logo">

    @if (submitted) {
      <div role="status" aria-live="polite" class="contact-card__success">
        <h1 class="contact-card__heading">Thanks for reaching out.</h1>
        <p>We'll be in touch at <strong>{{ form.value.email }}</strong> shortly.</p>
      </div>
    } @else {
      <h1 class="contact-card__heading">Contact Sales</h1>
      <p class="contact-card__sub">Interested in Rightbin&#8482; for your building? Send us a message and we'll get back to you.</p>

      @if (error) {
        <p role="alert" class="contact-card__error">Something went wrong. Please try again or email <a href="mailto:info@rightbin.io">info&#64;rightbin.io</a> directly.</p>
      }

      <form [formGroup]="form" (ngSubmit)="submit()" class="contact-card__form" novalidate>
        <mat-form-field appearance="outline" class="contact-card__field">
          <mat-label>Name</mat-label>
          <input matInput formControlName="name" autocomplete="name" aria-required="true"
                 [attr.aria-invalid]="form.get('name')?.invalid && form.get('name')?.touched">
        </mat-form-field>

        <mat-form-field appearance="outline" class="contact-card__field">
          <mat-label>Work email</mat-label>
          <input matInput formControlName="email" type="email" autocomplete="email" aria-required="true"
                 [attr.aria-invalid]="form.get('email')?.invalid && form.get('email')?.touched">
        </mat-form-field>

        <mat-form-field appearance="outline" class="contact-card__field">
          <mat-label>Company</mat-label>
          <input matInput formControlName="company" autocomplete="organization" aria-required="true"
                 [attr.aria-invalid]="form.get('company')?.invalid && form.get('company')?.touched">
        </mat-form-field>

        <mat-form-field appearance="outline" class="contact-card__field">
          <mat-label>Message</mat-label>
          <textarea matInput formControlName="message" rows="5" aria-required="true"
                    [attr.aria-invalid]="form.get('message')?.invalid && form.get('message')?.touched"></textarea>
        </mat-form-field>

        <button mat-flat-button type="submit" class="contact-card__submit"
                [disabled]="form.invalid || loading"
                [attr.aria-busy]="loading">
          {{ loading ? 'Sending…' : 'Send Message' }}
        </button>
      </form>
    }
  </div>
</main>
